export default __webpack_public_path__ + "static/media/banner-partnership@2x.7b18645d.png";